<template>
  <div>
    <div class="head-title">客服列表</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、要使用客服功能必须到风控管理-参数配置里面配置微信客服密钥Secret，然后点击查看教程配置接收事件回调地址。
          </p>
          <p>
            2、创建客服相当于创建了接待群，是需要设置接待人员的，可以设置成公司成员，也可以设置成整个部门。
          </p>
          <p>
            3、复制链接，是可以把这个链接配置到需要使用客服的地方，点击就会进入直接与客服对话。<span
            @click="show3 = true"
            class="help-link"
              >配置教程</span
            >
            
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <div class="header-menu">
        <div class="menu-left">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd"
            >添加客服</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-refresh"
            :loading="updateLoading"
            @click="getRenew"
            >同步客服</el-button
          >
        </div>
      </div>
      <div class="container">
        <el-table :data="tableData" v-loading="tableLoading" border >
          <el-table-column
            label="客服名称"
            prop="name"
            width="160"
          ></el-table-column>
          <el-table-column label="客服头像" prop="avatar">
            <template slot-scope="scope">
              <el-image
                style="width: 4.0rem; height: 4.0rem"
                :src="scope.row.avatar"
                :preview-src-list="[scope.row.avatar]"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" >
            <template slot-scope="scope">
              <span style="margin-left: 1.0rem;width:24.0rem">{{ scope.row.createtime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="300">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleDelete(scope.row)"
                style="color:#f00000 !important"
                >删除</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click="receptionStaff(scope.row)"
                >接待人员</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click="departmentStaff(scope.row)"
                >接待部门</el-button
              >
              <el-button type="text" size="mini" @click="copyLink(scope.row)"
                >复制链接</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          @pagination="getList"
        />
      </div>
    </div>
    <el-dialog title="编辑客服信息" center :visible.sync="show1" width="30%">
      <el-form ref="ruleForm" :model="form">
        <el-form-item
          required=""
          label="客服名称"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item required label="客服头像" :label-width="formLabelWidth">
          <el-upload
            class="upload-demo"
            :action="`${baseURL}/api/Alioss/upload_temp_uploadimg`"
            :data="upParams"
            :on-preview="handlePreviewEdit"
            :on-remove="handleRemoveEdit"
            accept="image/png, image/jpg"
            :on-success="handleSuccess"

            :file-list="fileListEdit"
            list-type="picture"
            :limit="1"
          >
            <el-button type="primary" @click="clear">上传图片</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb，图片尺寸请保证在350*210像素
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show1 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit1" :loading="loading1"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="添加客服"  center :visible.sync="show2" width="30%">
      <el-form ref="ruleForm" :model="formAdd">
        <el-form-item required label="客服名称" :label-width="formLabelWidth">
          <el-input v-model="formAdd.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item required label="客服头像" :label-width="formLabelWidth">
          <el-upload
            class="upload-demo"
            :action="`${baseURL}/api/Alioss/upload_temp_uploadimg`"
            :data="upParams"
            :on-preview="handlePreviewAdd"
            :on-remove="handleRemoveAdd"
            accept="image/png, image/jpg"
            :on-success="handleSuccessAdd"
            :file-list="fileListAdd"
            list-type="picture"
            :limit="1"
          >
            <el-button type="primary">上传图片</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb，图片尺寸请保证在350*210像素
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show2 = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit2" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="配置教程" center :visible.sync="show3" width="70%">
      <div style="width: 100%; height: 100%; text-align: center">
        <img src="../../assets/study.png" alt />
        <img src="../../assets/study1.png" alt="" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show3 = false">取 消</el-button>
        <el-button type="primary" @click="show3 = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import pagination from "@/components/Pagination";

export default {
  name: "customerServiceList",
  components: {
    pagination,
  },
  data() {
    return {
      baseURL: this.axios.defaults.baseURL,
      total: 0,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 20,
      },
      tooken: "",
      searchVal: "",
      show1: false,
      form: {
        name: "",
        avatar: "",
      },
      formAdd: {
        name: "",
        avatar: "",
      },
      formLabelWidth: "8.0rem",
      fileListEdit: [
        {
          url: "",
        },
      ],
      upParams: {},
      media_id1: "", //编辑时上传头像返的media_id
      open_kfid: "", //编辑客服信息时使用
      fileListAdd: [
        {
          url: "",
        },
      ],
      show2: false,
      media_id2: "", //添加时上传头像返的media_id
      updateLoading: false,
      loading: false, //添加时确定按钮状态
      loading1: false, //编辑时确定按钮状态
      show3: false,
      //bianjibtn:true,
      tableLoading: true,
    };
  },

  computed: {},

  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
      this.upParams.account_id = this.tooken.account_id;
    }
    this.getList();
  },

  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    getList() {
      this.axios
        .post(
          "/crm/CustomerService/getServiceList",
          qs.stringify({
            account_id: this.tooken.account_id,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == 1) {
            this.loading = false;
            this.loading1 = false;
            this.tableData = res.data.data;
            this.total = res.data.count;

          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    onAdd() {
      this.show2 = true;
      this.fileListAdd = [];
      this.formAdd.name = "";
      this.formAdd.avatar = "";
    },
    onSearch() {},
    handleEdit(e) {
      this.show1 = true;
      this.axios
        .post(
          "/crm/CustomerService/getServiceList",
          qs.stringify({
            account_id: this.tooken.account_id,
            id: e.id,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.form.name = res.data.data[0].name;
            this.form.avatar = res.data.data[0].avatar;
            this.fileListEdit[0].url = res.data.data[0].avatar;
            this.open_kfid = res.data.data[0].open_kfid;
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {

        });
    },
    handleDelete(e) {
      this.$confirm("此操作将永久删除该条数据，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CustomerService/deleteService",
              qs.stringify({
                account_id: this.tooken.account_id,
                open_kfid: e.open_kfid,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getList();
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handlePreviewEdit(file) {
      console.log(file);
    },
    handleRemoveEdit(file, fileList) {
      console.log(file);
      console.log(fileList);
    },
    handleSuccess(response, file, fileList) {
      if(response.data == null){
        this.$message.error('图片格式不正确');
      }
      this.media_id1 = response.data.media_id;
    },

    handleSuccessAdd(response, file, fileList) {
      if(response.data == null){
        this.$message.error('图片格式不正确');
      }
      this.media_id2 = response.data.media_id;

    },
    handlePreviewAdd(file) {
      console.log(file);
    },
    handleRemoveAdd(file, fileList) {
      console.log(file);
      console.log(fileList);
    },
    async onSubmit1() {
      if(this.media_id1 == ""){
        this.$message.error('客服头像为空或格式不正确');
        return
      }

      this.loading1 = true;
      const res = await this.axios({
        url: "/crm/CustomerService/editService",
        method: "POST",
        data: {
          account_id: this.tooken.account_id,
          name: this.form.name,
          media_id: this.media_id1,
          open_kfid: this.open_kfid,
        },
      });
      if (res.data.code == 1) {
        this.$message({
          message: res.data.msg,
          type: "success",
        });
        this.getList();
        this.show1 = false;
        this.fileListEdit = [ {
          url: ''
        }]
      } else {
        this.loading1 = false;
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
    async onSubmit2() {
      if(this.media_id2 == ""){
        this.$message.error('客服头像为空或格式不正确');
        return
      }
      this.loading = true;
      const res = await this.axios({
        url: "/crm/CustomerService/addService",
        method: "POST",
        data: {
          account_id: this.tooken.account_id,
          name: this.formAdd.name,
          media_id: this.media_id2,
        },
      });
      if (res.data.code == 1) {
        this.$message({
          message: "添加成功",
          type: "success",
        });
        this.getList();
        this.show2 = false;
      } else if (res.data.code == 88) {
        this.loading = false;
        this.$message({
          message: res.data.msg,
          type: "info",
        });
        this.$router.push("/register/user/param");
      } else {
        this.loading = false;
          this.$message({
          message: '添加失败',
          type: "error",
        });
      }
    },
    async getRenew() {
      this.updateLoading = true;
      // 拉取更新数据
      const res = await this.axios({
        url: "/crm/CustomerService/updateServiceList",
        method: "POST",
        data: {
          account_id: this.tooken.account_id,
        },
      });
      if (res.data.code == 1) {
        this.getList();
        this.updateLoading = false;
        this.$message({
                  message: res.data.msg,
                  type: "success",
                });
      } else {
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
    receptionStaff(e) {
      localStorage.setItem("open_kfid", e.open_kfid);
      this.$router.push({
        path: "/register/user/receptionStaffList",
      });
    },
    departmentStaff(e) {
      localStorage.setItem("open_kfid", e.open_kfid);
      this.$router.push({
        path: "/register/user/departmentStaffList",
      });
    },
    async copyLink(e) {
      const res = await this.axios({
        url: "/crm/CustomerService/getServiceUrl",
        method: "POST",
        data: {
          account_id: this.tooken.account_id,
          open_kfid: e.open_kfid,
        },
      });
      if (res.data.code == 1) {
        const content = res.data.data;
        const input = document.createElement("input");
        input.setAttribute("readonly", "readonly");
        input.setAttribute("value", `${content}`);
        document.body.appendChild(input);
        input.select();
        if (document.execCommand("copy")) {
          document.execCommand("copy");
          this.$message.success("复制成功");
        }
        document.body.removeChild(input);
      } else {
        this.$message({
          message: res.data.msg,
          type: "error",
        });
      }
    },
    clear() {
      this.fileListEdit = [];
      console.log(this.fileListEdit);
    },
  },
};
</script>
<style  scoped>
body {
  margin: 0;
}
.container{
  margin-top: 2.0rem;
}
.el-table .el-button {
    width: 9.0rem;
    margin: .0rem !important;
    padding-right: .0rem !important;
    text-align: left;
}
.el-dialog img{
  width: 100%;
}
</style>